import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const BaseIcon = ({ children, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {children}
  </svg>
);

export const SearchIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </BaseIcon>
);

export const MapPinIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M12 21s6-5.2 6-11a6 6 0 1 0-12 0c0 5.8 6 11 6 11Z" />
    <circle cx="12" cy="10" r="2.5" />
  </BaseIcon>
);

export const CalendarIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M16 3v4M8 3v4M3 10h18" />
  </BaseIcon>
);

export const LanguagesIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M4 5h8" />
    <path d="M8 5c0 6-2.5 9-4 10" />
    <path d="M5 11c1.2 1.9 3 3.4 5 4" />
    <path d="M14 7h6" />
    <path d="m15 19 3-8 3 8" />
    <path d="M16 16h4" />
  </BaseIcon>
);

export const PhoneIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M22 16.9v2a2 2 0 0 1-2.2 2A19.8 19.8 0 0 1 3.1 4.2 2 2 0 0 1 5.1 2h2a2 2 0 0 1 2 1.7l.4 2.6a2 2 0 0 1-.6 1.8l-1.2 1.2a16 16 0 0 0 6.8 6.8l1.2-1.2a2 2 0 0 1 1.8-.6l2.6.4A2 2 0 0 1 22 16.9Z" />
  </BaseIcon>
);

export const SunIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2.5M12 19.5V22M4.9 4.9l1.8 1.8M17.3 17.3l1.8 1.8M2 12h2.5M19.5 12H22M4.9 19.1l1.8-1.8M17.3 6.7l1.8-1.8" />
  </BaseIcon>
);

export const MoonIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8Z" />
  </BaseIcon>
);

export const MusicIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M9 18V6l10-2v12" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="16" cy="16" r="3" />
  </BaseIcon>
);

export const PartyIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="m4 4 8 8" />
    <path d="m13 3 8 8" />
    <path d="M7 14 3 21l7-4 4-7" />
    <path d="M14 7 9 2" />
    <path d="M17 10 22 5" />
  </BaseIcon>
);

export const TheaterIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M4 5c2 1.5 4.7 1.5 8 0 3.3 1.5 6 1.5 8 0v8c0 4.4-3.6 8-8 8s-8-3.6-8-8Z" />
    <path d="M9 10h.01M15 10h.01" />
    <path d="M8.5 15c1 .8 2.2 1.2 3.5 1.2s2.5-.4 3.5-1.2" />
  </BaseIcon>
);

export const MicIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M12 18v3M8 21h8" />
  </BaseIcon>
);

export const PaletteIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M12 3a9 9 0 1 0 0 18h1.4a2.6 2.6 0 0 0 0-5.2h-.7A1.7 1.7 0 0 1 11 14V13a2 2 0 0 1 2-2h1a5 5 0 0 0 0-8Z" />
    <circle cx="7.5" cy="10" r="1" />
    <circle cx="9.5" cy="7" r="1" />
    <circle cx="14.5" cy="7" r="1" />
  </BaseIcon>
);

export const MountainIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <path d="M3 20 10 8l3 5 2-3 6 10Z" />
    <path d="m10 8 1.5 2.5L13 8" />
  </BaseIcon>
);

export const LaptopIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <rect x="4" y="5" width="16" height="10" rx="2" />
    <path d="M2 19h20" />
  </BaseIcon>
);

export const FilmIcon = (props: IconProps) => (
  <BaseIcon {...props}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M7 5v14M17 5v14M3 9h4M3 15h4M17 9h4M17 15h4" />
  </BaseIcon>
);